import { useCallback } from "react";

export interface ToggleProps {
  value: boolean;
  onChange: (next: boolean) => void;
  size?: number;
  disabled?: boolean;
  label?: string;
}

export function Toggle({
  value,
  onChange,
  size = 12,
  disabled = false,
  label,
}: ToggleProps) {
  const handleClick = useCallback(() => {
    onChange(!value);
  }, [onChange, value]);

  const rootStyle: React.CSSProperties = disabled
    ? { opacity: 0.5, pointerEvents: "none", cursor: "not-allowed" }
    : {};

  return (
    <div style={rootStyle}>
      <svg
        width={size}
        height={size}
        viewBox={`0 0 ${size} ${size}`}
        onClick={handleClick}
        aria-label={label}
        role="checkbox"
        aria-checked={value}
        style={{ cursor: "pointer", display: "block", flexShrink: 0 }}
      >
        <circle
          cx={size / 2}
          cy={size / 2}
          r={size / 2 - 1}
          fill={value ? "var(--paper-ink)" : "transparent"}
          stroke="var(--paper-ink)"
          strokeWidth={1}
        />
      </svg>
    </div>
  );
}
